











































































































































































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { makeid } from '@/core/utils/utils';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'PaymentPlanDialog',
  components: {
    ValidationObserver,
  },
  props: {
    productId: {
      type: Number,
    },
    currency: {
      type: String,
    },
    fixedPriceAmount: {
      type: Number,
      default: 0,
    },
    paymentPlan: {
      type: Object,
      default(): PaymentPlanResponse {
        return {
          billing_frequency_days: 30,
          currency: null,
          disable_access_after_days: 10,
          initial_payment_amount: null,
          number_of_subsequent_payments: 11,
          subsequent_payment_amount: null,
          activation_code: null,
        } as PaymentPlanResponse;
      },
    },
    onConfirm: null,
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
    }),
    titleKey() {
      return this.paymentPlanModel?.id
        ? 'PRODUCTS.TITLE.EDIT_PAYMENT_PLAN'
        : 'PRODUCTS.TITLE.ADD_PAYMENT_PLAN';
    },
    subsequentPaymentOptions() {
      return [...Array(36).keys()].map(e => e + 1).flat();
    },
    intervalOptions() {
      return [7, 14, 21, 30, 60, 90, 180, 365];
    },
    disableAfterDaysOptions() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
    },
    getPaymentPlanTotal() {
      const p = this.paymentPlanModel;
      try {
        const total =
          parseFloat(p.initial_payment_amount || 0) +
          p.number_of_subsequent_payments *
            parseFloat(p.subsequent_payment_amount || 0);
        return total.toFixed(2);
      } catch (error) {
        console.log(typeof total);
        console.log(error);
        return '';
      }
    },
    isSecretPlan() {
      return this.paymentPlanModel?.activation_code?.length > 0;
    },
    purchaseUri() {
      const productId = this.productId;
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/buy/product/${productId}?pp=${this.paymentPlanModel.activation_code}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/buy/product/${productId}?pp=${this.paymentPlanModel.activation_code}`
        );
        return uri;
      }
    },
  },
  data() {
    return {
      paymentPlanModel: null as PaymentPlanResponse,
      formError: null,
    };
  },
  methods: {
    toggleSecretPlan(enabled) {
      if (enabled) {
        return (this.paymentPlanModel.activation_code = makeid(8));
      } else {
        return (this.paymentPlanModel.activation_code = null);
      }
    },
    confirm() {
      this.onConfirm(this.paymentPlanModel);
      this.$emit('close');
    },
  },
  mounted() {
    this.paymentPlanModel = cloneDeep(this.paymentPlan);
    if (!this.paymentPlanModel.currency) {
      this.paymentPlanModel.currency = this.currency;
    }
    if (!this.paymentPlanModel.initial_payment_amount) {
      this.paymentPlanModel.initial_payment_amount = this.fixedPriceAmount / 10;
    }
    if (!this.paymentPlanModel.subsequent_payment_amount) {
      this.paymentPlanModel.subsequent_payment_amount =
        this.fixedPriceAmount / 10;
    }
  },
});
